import { withJsonFormsControlProps } from "@jsonforms/react";
import { File } from "pepsico-ds";
import PropTypes from "prop-types"; // Import PropTypes library
import { useState } from "react";

const SimpleFileUploadField = (props) => {
  const { handleChange, label, path, uischema, required } = props;
  const [error, setError] = useState(null);
  const acceptedExtensions = uischema.accept || ".jpeg,.jpg,.png";
  const variant = uischema.options?.variant || "edit";
  const multiple = uischema?.multiple || false;

  const handleFileUpload = (newFiles) => {
    const validFiles = validateFiles(newFiles);
    if (validFiles) {
      handleChange(path, validFiles);
    }
  };

  const validateFiles = (newFiles) => {
    const filesArray = Array.isArray(newFiles) ? newFiles : [newFiles];
    const validFiles = [];

    for (const file of filesArray) {
      const fileExtension = file.name.split(".").pop();
      const hasIncludeExt = acceptedExtensions.includes(`.${fileExtension}`);
      if (!hasIncludeExt) {
        setError("Invalid file type");
        return null;
      }
      setError(null);
      validFiles.push(file);
    }

    return multiple ? validFiles : validFiles[0];
  };

  return (
    <>
      <div className="fileUploadHeader">
        <span className="label-text $font-xsmall-regular">
          <label>{label}</label>
        </span>
        {required && (
          <span className="required-text $font-xxsmall-bold">*Required</span>
        )}
      </div>
      <File
        className="fileUploader"
        accept={acceptedExtensions}
        label={uischema?.dragDropText || label}
        variant={variant}
        multiple={multiple}
        onUpdate={handleFileUpload}
      />
      {error && (
        <div className="display-flex gap-2 align-items-center mt-2">
          <span style={{ color: "red", fontSize: "14px" }}>{error}</span>
        </div>
      )}
    </>
  );
};

SimpleFileUploadField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  //data: PropTypes.object,
  path: PropTypes.string,
  //errors: PropTypes.array,
  //schema: PropTypes.object,
  uischema: PropTypes.object,
  required: PropTypes.bool,
};

export const SimpleFileUploadFieldControl =
  withJsonFormsControlProps(SimpleFileUploadField);
